import CookieConsentLib from "react-cookie-consent";

/**
 * Cookie consent banner component that appears at the bottom of the page.
 * Uses theme-aware colors and includes a link to the privacy policy.
 */
export function CookieConsent() {
  return (
    <CookieConsentLib
      location="bottom"
      buttonText="Accept"
      cookieName="cookie_eu_consented"
      style={{
        padding: "0px 40px",
        background: "var(--surface-elevation-2)",
        color: "var(--text-color)",
        alignItems: "center",
      }}
      buttonStyle={{
        background: "var(--primary-color)",
        color: "var(--primary-contrast-color)",
        fontSize: "14px",
        padding: "10px 20px",
        borderRadius: "4px",
      }}
      expires={365}
    >
      Cookies help us deliver our services. By using our services, you agree to our use of cookies.
      View our{" "}
      <a
        href="https://www.securityjourney.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "var(--primary-color)", textDecoration: "underline" }}
      >
        Privacy Policy
      </a>
      .
    </CookieConsentLib>
  );
}
